import { render, staticRenderFns } from "./ModalBoletosExcluidos.vue?vue&type=template&id=9b9c2524&scoped=true"
import script from "./ModalBoletosExcluidos.vue?vue&type=script&lang=js"
export * from "./ModalBoletosExcluidos.vue?vue&type=script&lang=js"
import style0 from "./ModalBoletosExcluidos.vue?vue&type=style&index=0&id=9b9c2524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9c2524",
  null
  
)

export default component.exports